// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.coffee.

import {Application} from 'stimulus'
import {definitionsFromContext} from 'stimulus/webpack-helpers'

const application = Application.start()
const context = require.context('.', true, /_controller\.coffee$/)
application.load(definitionsFromContext(context))
